import { render } from "./index.vue?vue&type=template&id=8af97f68&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=8af97f68&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8af97f68"

export default script